module.exports = __webpack_public_path__ + "img/86.4a65d845.jpg";